import { useMutation } from '@tanstack/react-query';
import { useRequestSections } from '../api/request';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/Store';
import { Permissions } from '../constants';
import {
  setOrder,
  updateRecentOrders,
} from '../redux/reducer/inspact/order_reducer';
import { checkPermission } from '../utils';
import { useFindPermissions } from '../utils/helpers/useFindPermissions';
import Notifications from '../ui/molecules/toast/Notifications';
import { useNavigate } from 'react-router-dom';
import { encryptJSON } from '../utils/helpers/Encryption';

const useWorkOrderNumberSearch = () => {
  const { Search } = useRequestSections();
  const dispatch = useDispatch();
  const { canSearchWorkOrder } = useFindPermissions();
  const navigate = useNavigate();

  const {
    mutateAsync: searchWorkOrder,
    data: searchWorkOrderResults,
    isPending: searchWorkOrderResultsPending,
    isSuccess: searchResultsSuccessful,
    isError: searchResultsError,
  } = useMutation({
    mutationFn: async (parameter: string) => {
      if (canSearchWorkOrder) {
        const response = await Search?.getOrderSearchResults(parameter);
        const result = response?.data;

        if (result) {
          updateRecentOrders(dispatch, result);
          dispatch(
            setOrder({
              orderNumber: result?.orderNumber,
              propertyLoanId: result?.propertyLoanId,
            })
          );
          navigate(
            `/submissions/${result?.orderNumber}/${result?.propertyLoanId}`
          );
        }

        return result;
      } else
        return Notifications(
          'You do not have permission to search work order',
          0
        );
    },
  });
  return {
    searchWorkOrder,
    searchWorkOrderResults,
    searchWorkOrderResultsPending,
    searchResultsSuccessful,
    searchResultsError,
  };
};

export default useWorkOrderNumberSearch;
